
    export default {
        props: {
          page: {
            type: Object,
            default() {
                return {}
            }
          },
        },
        computed: {

        }
    }
